import { GeospatialInsightCardsList } from '../../components/geospatial-intelligence-page';
import type { Risk } from '../../types/api';

interface GeospatialInsightSectionProps {
  risks: Risk[];
  selectedMapArea: string | null;
}

export function GeospatialInsightSection({ risks, selectedMapArea }: GeospatialInsightSectionProps) {
  return (
    <section
      className="geo-layout__insights geo-panel geo-panel--insights geospatial-placeholder geospatial-placeholder--secondary geospatial-placeholder--sidebar"
      aria-label="Risk and opportunity insights"
    >
      <GeospatialInsightCardsList risks={risks} selectedMapArea={selectedMapArea} />
    </section>
  );
}
